module.exports = __webpack_public_path__ + "static/img/icon-file.1caf40ed.png";